// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2Lkyz","location":"Header_location__1tQ1E"};